export default "__VITE_ASSET__DlxhD9TT__"